<!-- Add embed-specific class to container -->
<div [ngClass]="{
  'embed-mode': isEmbedMode,
  'no-financial-application': !haveApplication && config.type === applicationType.financial_aid,
  'no-application': !haveApplication && config.type !== applicationType.financial_aid
}">
<div *ngIf="!haveApplication"
  [ngClass]="config.type === applicationType.financial_aid ? 'no-financial-application' : 'no-application'">
  <h1>{{ config.noApplicationText }}</h1>
  <img src="../../../assets/images/backgrounds/noDocuments.jpg" [alt]="config.noApplicationText" />
  <button class="btn btn-primary" type="button" routerLink="/dashboard" *ngIf="!isEmbedMode">Go back</button>
</div>

<!-- Loading indicator -->
<div *ngIf="isLoading" class="loading-container">
  <div class="spinner"></div>
  <p>Loading {{ config.displayName.toLowerCase() }}...</p>
</div>

<!-- Application form -->
<div [id]="config.type === applicationType.financial_aid ? 'financialAidContent' : 'applicationContent'"
  *ngIf="sections?.length > 0 && !isLoading">
  <!-- Header with status message and export button -->
  <div class="form-container">

    <div class="logo-container" *ngIf="showLogo && logoUrl">
      <img [src]="logoUrl" alt="Logo" />
    </div>

    <div *ngIf="showLogo" style="border: 1px solid;"></div>

    <div class="form-header" *ngIf="!isEmbedMode">
      <div *ngIf="adminView && !isApplicationMade" class="status-message info">
        No {{ config.displayName.toLowerCase() }} has been submitted.
      </div>
      <div *ngIf="adminView && isApplicationMade" class="status-message success">
        {{ config.displayName }} created!
      </div>

      <div *ngIf="adminView" class="admin-buttons">
        <button type="button" [disabled]="!isApplicationMade" class="btn btn-accent" (click)="exportApplication()">
          <span class="icon">⬇</span> Export
        </button>
      </div>
    </div>

    <!-- Add preview mode indicator at the top of the form -->
    <div *ngIf="isPreviewMode" class="preview-banner">
      <mat-icon>visibility</mat-icon>
      <span>Preview Mode - Submissions are disabled</span>
    </div>


    <!-- Form content -->
    <form id="pdfContent" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div *ngFor="let section of sections; let sIdx = index" class="section" [attr.data-section-id]="section.id">
        <h2>{{ section.title }}</h2>
        <p>{{ section.description }}</p>

        <div *ngFor="let question of section.questions; let qIdx = index" class="question">
          <!-- Text Input -->
          <div class="form-field" *ngIf="question.type === 'text'">
            <label [for]="getFormControlKey(sIdx, qIdx, question.name)">
              {{ question.name }}
              <span *ngIf="question.required && !isApplicationMade && !adminView" class="required">*</span>
            </label>
            <input [id]="getFormControlKey(sIdx, qIdx, question.name)" type="text" class="form-control"
              [formControlName]="getFormControlKey(sIdx, qIdx, question.name)"
              [class.error]="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name))" />
            <span class="error-message" *ngIf="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name))">
              This field is required.
            </span>
          </div>

          <!-- Number Input -->
          <div class="form-field" *ngIf="question.type === 'number'">
            <label [for]="getFormControlKey(sIdx, qIdx, question.name)">
              {{ question.name }}
              <span *ngIf="question.required && !isApplicationMade && !adminView" class="required">*</span>
            </label>
            <input [id]="getFormControlKey(sIdx, qIdx, question.name)" type="number" class="form-control"
              [formControlName]="getFormControlKey(sIdx, qIdx, question.name)"
              [class.error]="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name))" />
            <span class="error-message" *ngIf="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name))">
              This field is required.
            </span>
          </div>

          <!-- Email Input -->
          <div class="form-field" *ngIf="question.type === 'email'">
            <label [for]="getFormControlKey(sIdx, qIdx, question.name)">
              {{ question.name }}
              <span *ngIf="question.required && !isApplicationMade && !adminView" class="required">*</span>
            </label>
            <input [id]="getFormControlKey(sIdx, qIdx, question.name)" type="email" class="form-control"
              [formControlName]="getFormControlKey(sIdx, qIdx, question.name)"
              [class.error]="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name))" />
            <span class="error-message"
              *ngIf="form.get(getFormControlKey(sIdx, qIdx, question.name))?.hasError('email') && form.get(getFormControlKey(sIdx, qIdx, question.name))?.touched && !form.get(getFormControlKey(sIdx, qIdx, question.name))?.hasError('required') && !isApplicationMade && !adminView">
              Please enter a valid email address.
            </span>
            <span class="error-message"
              *ngIf="form.get(getFormControlKey(sIdx, qIdx, question.name))?.hasError('required') && form.get(getFormControlKey(sIdx, qIdx, question.name))?.touched && !isApplicationMade && !adminView">
              This field is required.
            </span>
          </div>

          <!-- Textarea -->
          <div class="form-field" *ngIf="question.type === 'textarea'">
            <label [for]="getFormControlKey(sIdx, qIdx, question.name)">
              {{ question.name }}
              <span *ngIf="question.required && !isApplicationMade && !adminView" class="required">*</span>
            </label>
            <textarea [id]="getFormControlKey(sIdx, qIdx, question.name)" class="form-control"
              [formControlName]="getFormControlKey(sIdx, qIdx, question.name)" rows="4"
              [class.error]="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name))"></textarea>
            <span class="error-message"
              *ngIf="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name)) && !isApplicationMade && !adminView">
              This field is required.
            </span>
          </div>

          <!-- Date Picker -->
          <div class="form-field" *ngIf="question.type === 'date'">
            <label [for]="getFormControlKey(sIdx, qIdx, question.name)">
              {{ question.name }}
              <span *ngIf="question.required && !isApplicationMade && !adminView" class="required">*</span>
            </label>
            <input [id]="getFormControlKey(sIdx, qIdx, question.name)" type="date" class="form-control"
              [formControlName]="getFormControlKey(sIdx, qIdx, question.name)"
              [class.error]="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name))" />
            <span class="error-message"
              *ngIf="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name)) && !isApplicationMade && !adminView">
              This field is required.
            </span>
          </div>

          <!-- Select Dropdown -->
          <div class="form-field" *ngIf="question.type === 'select'">
            <label [for]="getFormControlKey(sIdx, qIdx, question.name)">
              {{ question.name }}
              <span *ngIf="question.required && !isApplicationMade && !adminView" class="required">*</span>
            </label>
            <select [id]="getFormControlKey(sIdx, qIdx, question.name)" class="form-control"
              [formControlName]="getFormControlKey(sIdx, qIdx, question.name)"
              [class.error]="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name))">
              <option value="">Choose an option</option>
              <option *ngFor="let item of question.items" [value]="item.value">
                {{ item.value }}
              </option>
            </select>
            <span class="error-message"
              *ngIf="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name)) && !isApplicationMade && !adminView">
              This field is required.
            </span>
          </div>

          <!-- Terms checkbox with header and description -->
          <div class="form-field terms-container" *ngIf="question.type === 'terms'">
            <div class="terms-header">
              <h3>{{ question.name }}</h3>
            </div>
            <div class="terms-content">
              <input [id]="getFormControlKey(sIdx, qIdx, question.name)" type="checkbox" class="checkbox"
                [formControlName]="getFormControlKey(sIdx, qIdx, question.name)" />
              <div class="terms-text-container">
                <label [for]="getFormControlKey(sIdx, qIdx, question.name)" class="terms-text"
                  [innerHTML]="question.headerDescription"></label>
              </div>
            </div>
            <span class="error-message"
              *ngIf="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name)) && !isApplicationMade && !adminView">
              You must accept the terms to continue.
            </span>
          </div>

          <!-- Radio Buttons -->
          <div class="form-field" *ngIf="question.type === 'radio'">
            <fieldset>
              <legend>{{ question.name }}
                <span *ngIf="question.required && !isApplicationMade && !adminView" class="required">*</span>
              </legend>
              <div class="radio-group">
                <div class="radio-item" *ngFor="let item of question.items; let i = index">
                  <input [id]="getFormControlKey(sIdx, qIdx, question.name) + '_' + i" type="radio"
                    [name]="getFormControlKey(sIdx, qIdx, question.name)" [value]="item.value"
                    [formControlName]="getFormControlKey(sIdx, qIdx, question.name)" />
                  <label [for]="getFormControlKey(sIdx, qIdx, question.name) + '_' + i">{{ item.value }}</label>
                </div>
              </div>
            </fieldset>
            <span class="error-message"
              *ngIf="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name)) && !isApplicationMade && !adminView">
              Please select an option.
            </span>
          </div>

          <!-- Phone Input -->
          <div class="form-field" *ngIf="question.type === 'phone'">
            <label [for]="getFormControlKey(sIdx, qIdx, question.name)">
              {{ question.name }}
              <span *ngIf="question.required && !isApplicationMade && !adminView" class="required">*</span>
            </label>
            <input [id]="getFormControlKey(sIdx, qIdx, question.name)" type="tel" class="form-control"
              [formControlName]="getFormControlKey(sIdx, qIdx, question.name)" placeholder="Phone Number"
              [class.error]="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name))" />
            <span class="error-message"
              *ngIf="form.get(getFormControlKey(sIdx, qIdx, question.name))?.hasError('required') && form.get(getFormControlKey(sIdx, qIdx, question.name))?.touched && !isApplicationMade && !adminView">
              Phone Number is required
            </span>
            <span class="error-message"
              *ngIf="form.get(getFormControlKey(sIdx, qIdx, question.name))?.hasError('invalidPhoneNumber') && form.get(getFormControlKey(sIdx, qIdx, question.name))?.touched && !isApplicationMade && !adminView">
              Invalid phone number format.
            </span>
          </div>

          <!-- Checkbox Group -->
          <div class="form-field" *ngIf="question.type === 'checkbox'">
            <fieldset>
              <legend>{{ question.name }}</legend>
              <div class="checkbox-group" *ngIf="!isApplicationMade && !adminView">
                <div class="checkbox-item" *ngFor="let item of question.items; let i = index"
                  [formArrayName]="getFormControlKey(sIdx, qIdx, question.name)">
                  <input [id]="getFormControlKey(sIdx, qIdx, question.name) + '_' + i" type="checkbox" [formControlName]="i" />
                  <label [for]="getFormControlKey(sIdx, qIdx, question.name) + '_' + i">{{ item.value }}</label>
                </div>
              </div>
              <!-- Display checked values in read-only mode -->
              <div class="checkbox-display" *ngIf="isApplicationMade || adminView">
                {{ getDisplayValue(question, sIdx, qIdx) }}
              </div>
            </fieldset>
          </div>

          <!-- HTML Section / Text Block -->
          <div class="form-field html-section" *ngIf="question.type === 'section'">
            <h3 *ngIf="question.name">{{ question.name }}</h3>
            <div class="section-content" [innerHTML]="question.headerDescription"></div>
          </div>


          <!-- Signature Pad -->
          <div *ngIf="question.type === 'signature'" class="signature-container form-field">
            <label>{{ question.name }} <span *ngIf="question.required && !isApplicationMade && !adminView"
                class="required">*</span></label>

            <!-- Show signature pad when form is editable -->
            <app-signing-pad *ngIf="!isApplicationMade && !adminView" [disabled]="isApplicationMade"
              [formControlName]="getFormControlKey(sIdx, qIdx, question.name)" ngDefaultControl></app-signing-pad>

            <!-- Show signature image when form is read-only -->
            <div *ngIf="(isApplicationMade || adminView) && form.get(getFormControlKey(sIdx, qIdx, question.name))?.value"
              class="signature-display">
              <img [src]="form.get(getFormControlKey(sIdx, qIdx, question.name))?.value" alt="Signature" />
            </div>
            <div *ngIf="(isApplicationMade || adminView) && !form.get(getFormControlKey(sIdx, qIdx, question.name))?.value"
              class="signature-display">
              <p>No signature provided</p>
            </div>

            <span class="error-message"
              *ngIf="isFieldInvalid(getFormControlKey(sIdx, qIdx, question.name)) && !isApplicationMade && !adminView">
              Signature is required.
            </span>
          </div>
        </div>
      </div>

      <!-- Submit button -->
      <button [disabled]="isApplicationMade || adminView || isSubmitting || isPreviewMode"
        class="btn btn-primary btn-submit" type="submit">
        <span *ngIf="!isSubmitting && !isPreviewMode">{{ config.submitButtonText }}</span>
        <span *ngIf="!isSubmitting && isPreviewMode">Preview Mode - Cannot Submit</span>
        <div *ngIf="isSubmitting" class="spinner spinner-small"></div>
      </button>
    </form>
  </div>
</div>
</div>